var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.083 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.509 4H4.977a.51.51 0 0 0-.51.51v1.533c0 .282.228.51.51.51h1.532a.51.51 0 0 0 .51-.51V4.51A.51.51 0 0 0 6.51 4zm8.936 10.979H4.722a.255.255 0 0 0-.256.255v.51c0 .142.115.256.256.256h10.723a.255.255 0 0 0 .255-.255v-.511a.255.255 0 0 0-.255-.255zm0-10.213H8.948a.255.255 0 0 0-.255.255v.51c0 .142.114.256.255.256h6.497a.255.255 0 0 0 .255-.255v-.51a.255.255 0 0 0-.255-.256zm0 3.404H4.722a.255.255 0 0 0-.256.256v.51c0 .141.115.255.256.255h10.723a.255.255 0 0 0 .255-.255v-.51a.255.255 0 0 0-.255-.256zm0 3.404H4.722a.255.255 0 0 0-.256.256v.51c0 .141.115.256.256.256h10.723a.255.255 0 0 0 .255-.256v-.51a.255.255 0 0 0-.255-.256z",
    fill: "#9C989E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.51479dbdb36fae14e07c43f5bd61e572.svg";
export { ForwardRef as ReactComponent };